import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { ButtonBase } from "../../../../common/components/form";
import * as API from "../../../lib/api.js";
import * as Links from "../../../lib/links.js";
import Wait from "../../Wait";
import WebsiteMarketingAd from "./WebsiteMarketingAd.jsx";
import WebsiteMarketingModal from "./WebsiteMarketingModal.jsx";

export default function WebsiteMarketing() {
    const { t } = useTranslation();
    const { id } = useParams();

    const history = useHistory();

    const [loading, setLoading] = React.useState(false);
    const [campaignsData, setCampaignsData] = React.useState([]);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [GTC, setGTC] = React.useState([]);

    React.useEffect(() => {
        id && Load(id);
    }, [id]);

    async function Load(id) {
        setLoading("<h2>Loading</h2>");

        await Promise.all([
            (async () => {
                const campaignsData = await API.GetGoogleAdsCampaign(id);

                // 0: "UNSPECIFIED",
                // 1: "UNKNOWN",
                // 2: "ACTIVE",
                // 3: "PAUSED",
                // 4: "REMOVED",
                const sortPriority = [0, 1, 3, 2, 4];
                const list = (campaignsData[0] || [])
                    .sort((a, b) => {
                        const _a = a.campaign_google_ads.time;
                        const _b = b.campaign_google_ads.time;
                        return _a === _b ? 0 : _a > _b ? -1 : 1;
                    })
                    .sort((a, b) => {
                        const _a = a.campaign.campaign.status;
                        const _b = b.campaign.campaign.status;
                        const priority = value => {
                            if (sortPriority.indexOf(value) !== -1) {
                                return sortPriority.indexOf(value);
                            }

                            return sortPriority.length; // end
                        };

                        return priority(_a) - priority(_b);
                    });

                setCampaignsData(list);
            })(),

            (async () => {
                const { list } = await API.GoogleGetTargetConstants();
                setGTC(list);
            })(),
        ]);

        setLoading(false);
    }

    function onUpdate() {
        id && Load(id);
    }

    function onCancelClick() {
        history.push(Links.Dashboard());
    }

    async function onAddCampaign() {
        setModalOpen(true);
    }

    function onModalClose(options = { load: false }) {
        setModalOpen(false);

        if (options?.load) {
            id && Load(id);
        }
    }

    return (
        <>
            <div className="website-settings analytics">
                <h2 className="panel-heading-text">{t("WebsiteMarketingTitle")}</h2>
                {/* {loading && <h2 className="panel-heading-text">{t("Loading")}...</h2>} */}

                {campaignsData?.map((item, index) => (
                    <WebsiteMarketingAd key={index} {...item} setLoading={setLoading} onUpdate={onUpdate} />
                ))}

                {!loading && (
                    <>
                        <div className="website-settings-actions">
                            <ButtonBase solid onClick={() => onCancelClick()}>
                                {t("Cancel")}
                            </ButtonBase>

                            <ButtonBase invert onClick={() => onAddCampaign()}>
                                {t("AddCampaign")}
                            </ButtonBase>
                        </div>
                    </>
                )}

                <WebsiteMarketingModal id={id} show={modalOpen} GTC={GTC} onModalClose={onModalClose} />
            </div>

            <Wait show={loading} />
        </>
    );
}
